var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "media-gallery-asset-modal" }, [
    _c(
      "div",
      { staticClass: "media-gallery-asset-modal__headline" },
      [
        _c("span", { staticClass: "lead" }, [
          _vm._v("\n        " + _vm._s(_vm.asset.headline) + "\n        "),
        ]),
        _vm._v(" "),
        _vm.asset.subline
          ? [
              _c("br"),
              _vm._v(
                "\n            " + _vm._s(_vm.asset.subline) + "\n        "
              ),
            ]
          : _vm._e(),
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "media-gallery-asset-modal__image" }, [
      _vm.asset.image
        ? _c("img", {
            staticClass: "img-fluid img",
            attrs: {
              src: _vm.asset.image,
              alt: _vm.asset.description
                ? _vm.asset.description
                : _vm.asset.headline,
              title: _vm.asset.description ? _vm.asset.description : "",
            },
          })
        : _vm.asset.thumbnail
        ? _c("img", {
            staticClass: "img-fluid thumb",
            attrs: {
              src: _vm.asset.thumbnail,
              alt: _vm.asset.description
                ? _vm.asset.description
                : _vm.asset.headline,
            },
          })
        : _c(
            "svg",
            {
              staticClass: "img-fluid",
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 160 160",
              },
            },
            [
              _c("g", { attrs: { fill: "none", "fill-rule": "evenodd" } }, [
                _c("path", {
                  attrs: {
                    fill: "#CCC",
                    "fill-rule": "nonzero",
                    d: "M93 29H39v103h81V56z",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    fill: "#FFF",
                    "fill-rule": "nonzero",
                    d: "M93 34v22h22v70H44V34z",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: { fill: "#ABABAB", d: "M71 94h59v22H71z" },
                }),
                _vm._v(" "),
                _c(
                  "text",
                  {
                    attrs: {
                      fill: "#000",
                      "font-size": "15",
                      "font-weight": "300",
                      transform: "translate(71 94)",
                    },
                  },
                  [
                    _c("tspan", { attrs: { x: "16", y: "17" } }, [
                      _vm._v(_vm._s(_vm.asset.meta_type.toUpperCase())),
                    ]),
                  ]
                ),
              ]),
            ]
          ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "media-gallery-asset-modal__information" }, [
      _c("div", { staticClass: "media-gallery-asset-modal__text" }, [
        _c("section", { staticClass: "media-gallery-asset-modal__section" }, [
          _c(
            "header",
            { staticClass: "media-gallery-asset-modal__section-header" },
            [_vm._v(_vm._s(_vm.$t("mediaGallery.modal.license.headline")))]
          ),
          _vm._v(" "),
          _vm.asset.copyright
            ? _c("p", [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("mediaGallery.modal.license.copyright")) +
                    ": " +
                    _vm._s(_vm.asset.copyright) +
                    "\n                "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n                    " +
                _vm._s(
                  _vm.asset.licenses?.includes(_vm.DownloadLicenseEnum.ONLINE)
                    ? _vm.$t("mediaGallery.modal.license.online.yes")
                    : _vm.$t("mediaGallery.modal.license.online.no")
                )
            ),
            _c("br"),
            _vm._v(
              "\n                    " +
                _vm._s(
                  _vm.asset.licenses?.includes(_vm.DownloadLicenseEnum.PRINT)
                    ? _vm.$t("mediaGallery.modal.license.print.yes")
                    : _vm.$t("mediaGallery.modal.license.print.no")
                )
            ),
            _c("br"),
            _vm._v(
              "\n                    " +
                _vm._s(
                  _vm.asset.licenses?.includes(
                    _vm.DownloadLicenseEnum.SHARE_THIRD_PARTY
                  )
                    ? _vm.$t("mediaGallery.modal.license.share.yes")
                    : _vm.$t("mediaGallery.modal.license.share.no")
                ) +
                "\n                "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("section", { staticClass: "media-gallery-asset-modal__section" }, [
          _c(
            "header",
            { staticClass: "media-gallery-asset-modal__section-header" },
            [_vm._v(_vm._s(_vm.$t("mediaGallery.modal.file_meta.headline")))]
          ),
          _vm._v(" "),
          _c("p", [
            _vm.asset.meta_width && _vm.asset.meta_height
              ? _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("mediaGallery.modal.file_meta.dimension")) +
                      ": " +
                      _vm._s(_vm.asset.meta_width) +
                      " x " +
                      _vm._s(_vm.asset.meta_height)
                  ),
                  _c("br"),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.asset.meta_dpi
              ? _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("mediaGallery.modal.file_meta.resolution")) +
                      ": " +
                      _vm._s(_vm.asset.meta_dpi)
                  ),
                  _c("br"),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                _vm._s(_vm.$t("mediaGallery.modal.file_meta.type")) +
                  ": " +
                  _vm._s(_vm.asset.meta_type.toLowerCase())
              ),
              _c("br"),
            ]),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                _vm._s(_vm.$t("mediaGallery.modal.file_meta.size")) +
                  ": " +
                  _vm._s(_vm.asset.meta_filesize)
              ),
              _c("br"),
            ]),
            _vm._v(" "),
            _vm.asset.meta_files
              ? _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("mediaGallery.modal.file_meta.content")) +
                      ": " +
                      _vm._s(_vm.asset.meta_files)
                  ),
                  _c("br"),
                ])
              : _vm._e(),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "media-gallery-asset-modal__actions" },
        [
          _c("global-input-checkbox", {
            attrs: {
              label: _vm.$t("mediaGallery.modal.actions.select"),
              value: _vm.isSelected,
            },
            on: {
              input: function ($event) {
                return _vm.$store.dispatch("toggleAssetSelection", _vm.asset.id)
              },
            },
          }),
          _vm._v(" "),
          _c(
            "global-button",
            {
              attrs: {
                icon: _vm.hasRunningRequest("download") ? "spin" : "download",
                disabled: _vm.hasRunningRequest("download"),
              },
              on: { click: _vm.downloadAsset },
            },
            [
              _vm._v(
                _vm._s(_vm.$t("mediaGallery.modal.actions.download")) +
                  "\n            "
              ),
            ]
          ),
          _vm._v(" "),
          !_vm.asset.collected
            ? _c(
                "global-button",
                {
                  attrs: {
                    icon: _vm.addRequestRunning ? "spin" : "collection-add",
                    theme: "secondary",
                    disabled: _vm.addRequestRunning,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$store.dispatch(
                        "toggleAssetCollection",
                        _vm.asset
                      )
                    },
                  },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$t("mediaGallery.modal.actions.addToCollection")
                      ) +
                      "\n            "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.asset.collected
            ? _c(
                "global-button",
                {
                  attrs: {
                    icon: _vm.removeRequestRunning
                      ? "spin"
                      : "collection-remove",
                    theme: "secondary",
                    disabled: _vm.removeRequestRunning,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$store.dispatch(
                        "toggleAssetCollection",
                        _vm.asset
                      )
                    },
                  },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$t(
                          "mediaGallery.modal.actions.removeFromCollection"
                        )
                      ) +
                      "\n            "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._t("actions"),
        ],
        2
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "media-gallery-asset-modal__pagination" },
      [_vm._t("pagination")],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }